var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.normalizedReasons.length)?_c('operation-panel',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"tone":"warning","chip-label":_vm.chipLabel,"chip-color":"warning"}},_vm._l((_vm.normalizedReasons),function(reason,index){return _c('div',{key:index,staticClass:"operation-blocked-reasons__item"},[_vm._v(" "+_vm._s(reason)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }